import { createSubsetSelector } from 'webui/utils/selectors';
export const vehicle_rf_indicators_config = createSubsetSelector(['rf_status']);
export const vehicle_rf_indicators_state = createSubsetSelector(['rf_status']);
